<template>
  <apexchart type="pie" height="320" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoanDist',
  data() {
    return {
      series: [],
      chartOptions: {
        title: {
          text: '贷款分布',
        },
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: ['涉农企业', '小微企业', '其它企业', '农民贷款', '小微企业主', '个体工商户', '其它个人'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        }],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      axios.get('/dashboard/loan_dist_data').then(res => {
        if (res.data.status === 1) {
          this.series = res.data.series
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
